<script>
import LImage from "@/components/l-Image/Image.vue";
import ToRoute from "@/utils/ToRoute";
import {mapState} from "vuex";
import LDialog from "@/components/l-dialog/l-dialog.vue";
import LoginService from "@/api/LoginService";
import MessageUtils from "@/utils/MessageUtils";
import StorageUtils from "@/utils/storageUtils";

export default {
  name: "HeadUser",
  components: {LImage, LDialog},
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  methods: {
    handleRouter(e) {
      this.isHover = false;
      // if (this.$route.name === 'user') {
      //   // 刷新当前页面 的路由传参
      //
      //   return
      // }
      ToRoute.toRoute(this.$router, e);
    },
    async handleExit() {
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await LoginService.logout();
        // StorageUtils.clear();
        StorageUtils.removeItem("token")
        StorageUtils.removeItem("userInfo")
        MessageUtils.success(this, '退出登录成功');
        ToRoute.toRoute(this.$router, '/login', {}, 1500);
      })
    },
  }
}
</script>

<template>
  <div class="headUser cp" @mouseenter="isHover = true" @mouseleave="isHover = false" v-if="userInfo">
    <div class="headUser-view">
      <l-image width="40px" height="40px" radius="50%" :src="userInfo.icon" :default-src="require('@/assets/image/logo2.png')"></l-image>
      <span class="headUser-view-name">{{ userInfo.name }}</span>
      <span :class="['iconfont' ,'icon-sanjiaoxing']"></span>
    </div>
    <div class="headUser-list" v-show="isHover">
      <div class="headUser-list-item" @click="handleRouter(`/user?name=UserInfo`)">
        <span class="iconfont icon-my-fill"></span>
        <span class="headUser-list-item-name">个人资料</span>
      </div>
      <div class="headUser-list-item" @click="handleRouter(`/user?name=ChangePassword`)">
        <span class="iconfont icon-lock-fill"></span>
        <span class="headUser-list-item-name">修改密码</span>
      </div>
      <div class="headUser-list-item" @click="handleExit()">
        <span class="iconfont icon-tuichu1"></span>
        <span class="headUser-list-item-name">退出登录</span>
      </div>
    </div>
    <LDialog ref="exit" title="是否要确认退出登录" @confirm="handleLogout()"></LDialog>
  </div>
</template>

<style scoped lang="scss">
.headUser {
  position: relative;

  &:hover {
    .headUser-view {
      .icon-sanjiaoxing {
        transform: rotate(180deg);
        transition: all 0.3s ease-in-out;
      }
    }
  }

  &-view {
    display: flex;
    align-items: center;
    color: var(--page-headFontSize);

    &-name {
      margin: 0 10px;
    }

    .icon-sanjiaoxing {
      transition: all 0.3s ease-in-out;
    }
  }

  &-list {
    position: absolute;
    width: 110px;
    top: 40px;
    right: 0;
    background-color: #fff;
    color: #000;
    padding-top: 10px;
    box-sizing: border-box;
    border-radius: 6px;

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 8px;

      .iconfont {
        font-size: 20px;
      }

      &-name {
        font-size: 16px;
      }
    }
  }
}
</style>